import feedbackReducer from './feedbackReducer';

export default feedbackReducer;
